@if (supportMode) {
	<div
		class="relative tw:h-14 tw:px-6 tw:py-2 tw:flex tw:gap-4 tw:items-center tw:justify-center tw:bg-success-highlight tw:text-success tw:font-semibold tw:text-sm"
		[ngClass]="{
			'tw:bg-danger-highlight': minutesToDeadline && minutesToDeadline <= 30,
			'tw:text-danger': minutesToDeadline && minutesToDeadline <= 30,
		}"
	>
		You are currently supporting {{ currentSchool }} <mat-icon>access_time</mat-icon>
		<span class="tw:w-18 tw:-ms-2">{{ hoursToDeadline }}: {{ minutesToDeadline }} : {{ secondsToDeadline }}</span>
	</div>
}
